var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"processing":_vm.processing,"signinError":_vm.signinError},on:{"processed":_vm.processSignin}})}
var staticRenderFns = []

export { render, staticRenderFns }